import queryString from "query-string";
import WineClub from "./WinceClub";
import Product from "./Product";

const SubscriptionDetails = ({ onNext }) => {
	const parsed = queryString.parse(location.search);
	const { clubId } = parsed;

	if (clubId) {
		return <WineClub clubId={clubId} onNext={onNext} />;
	}

	return <Product onNext={onNext} />;
};

export default SubscriptionDetails;
